export default __webpack_public_path__ + "static/media/paymentTutorial_mobile_top_Hk.634ef1f3.webp";